<template>
<section>
 <div class="btn1-content">
    <span class="btnspan">{{value}}</span>
     <input
        id="upFileidcus"
        class="cusinput"
        ref="upfile"
        type="file"
        @change="fileChange"
        accept="image/*, application/msexcel, application/msword, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        capture="*"
        multiple="multiple"
      />
 
  </div>
    <warningModal v-if="showmodal" @closeModal="closeModal"></warningModal>
</section>
</template>
<script>
import API from "../../../../service/index";
import commonAPI from "../../../../utils/common";
import store from '../../../../store/index';
import warningModal from './warningModal';
export default {
  name: "cusBtn1",
  props: {
    value: {
      type: String,
      default: () => {
        return "继续新增";
      }
    },
    isDelete:{
      type: Boolean,
      default: ()=>{
        return false
      }
    }
  },
  components:{ warningModal },
  data() {
    return {
       tempFile: [], //用来存 上传到服务器的文件
      tempFileList: [], //用来 存 已经上传的文件的 名字 大小 类型等数据
      temEvent: null,
      showmodal: false
    };
  },
  watch:{

  },
  methods: {
    resetFile(){
      if(this.temEvent){
        this.temEvent.target.value = ''
      }
    },
    closeModal(){
      this.showmodal = false;
    },
    // addbtnClick() {
    //   if (this.isGoAndroidandIOS) {
    //     // this.$router.push({ path: "/appraise/add_enclosure" });
    //     const a = document.querySelector("#upFileid");
    //     if (a) a.click();
    //   } else {
    //     this.$emit("addbtnClick");
    //   }
    // },
    fileChange(event) {
      //  this.$refs.upfile.change()
      // console.log('----值：', event);
      // this.$router.push({ path: "/appraise/add_enclosure", query: { fields: event.target.files} });
     
      this.temEvent = event;
      this.tempFile = [];
      this.tempFileList = [];
      this.tempFile = event.target.files;
      if (this.tempFile.length <= 0) {
        return false;
      }
      if (this.tempFile.length > 10) {
        this.$toast("最多可上传10个附件文件");
        return false;
      }
      
      for( let i = 0 ; i< this.tempFile.length; i++){
        
         if(this.tempFile[i].type !== 'application/pdf'){
           //提示 只能选PDF
           console.log('----这个位置type:', this.tempFile[i].type);
           this.showmodal = true;
           return false;
         }
      }
      API.getCOStoken({}).then(res => {
        console.log("---token:", res);
        this.cosArg = res.data;
        this.cos = new COS({
          getAuthorization: function(options, callback) {
            callback({
              TmpSecretId: res.data.tmpSecretId,
              TmpSecretKey: res.data.tmpSecretKey,
              XCosSecurityToken: res.data.sessionToken,
              ExpiredTime: res.data.expiredTime
            });
          }
        });
        this.uploadFile();
      });
    },
    async uploadFile() {
      let cosKey = "";
       const _this = this;
      console.log("this.tempFile:", this.tempFile);
      store.dispatch('refund/setLoading', true)
      for (let i = 0; i < this.tempFile.length; i++) {
        let cosKey = `${commonAPI.getProcess()}/${new Date().getTime()}/${
          this.tempFile[i].name
        }`;
        // console.log('-----单个文件对象:', this.tempFile[i]);

        this.cos.putObject(
          {
            Bucket: this.cosArg.bucket,
            Region: this.cosArg.region,
            Key: cosKey,
            Body: this.tempFile[i],
            onHashProgress: function(progressData) {
              console.log("校验中", JSON.stringify(progressData));
            },
            onProgress: function(progressData) {
              console.log("上传中", JSON.stringify(progressData));
            }
          },
          (err, res) => {
            // console.log(err, res);
            // console.log("----上传之后返回的结果：", res);
            if (!err) {
              let name = _this.tempFile[i].name.substring( 0, _this.tempFile[i].name.lastIndexOf("."));
              let obj = {
                fileName: name,
                fileType: commonAPI.getFileType( this.tempFile[i].type),
                fileSize: commonAPI.fixBtoKBorMB(this.tempFile[i].size),
                fileSource: "app",
                fileKind: "common",
                filePath: cosKey,
                // fileUrl: res.Location
              };
              this.tempFileList.push(obj);
              if ((i+1) >= this.tempFile.length) {
                store.dispatch('refund/setLoading', false);
                this.$emit('fields', this.tempFileList)
                //  this.temEvent.target.value = ""
              }
            }
            // this.temEvent.target.value = ""
          }
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
.btn1-content {
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(54, 179, 116, 1);
  position: relative;
  line-height: 40px;
  text-align: center;
  overflow: hidden;
}
.cusinput {
  width: 100%;
  height: 40px;
  display: inline-block;
  //    border: 1px solid red;
  position: relative;
  //    left: 0px;
  //    top: 0px;
  opacity: 0;
  -ms-filter: "alpha(opacity=0)";
}
.btnspan {
  position: absolute;
  display: inline-block;
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(54, 179, 116, 1);
}
</style>
